import { PATHWAY } from "@/constants/testIds";
import { POSITIONING } from "@/lib/pathwayData";

export default function PositioningStrip() {
  return (
    <div
      data-testid={PATHWAY.positioningStrip}
      className="border-b hairline bg-[#111111]"
    >
      <div className="mx-auto max-w-7xl px-6 py-5 md:px-12 md:py-6">
        <div className="grid gap-4 md:grid-cols-[220px_1fr] md:gap-10">
          <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-amber-500">
            Platform position
          </div>
          <div>
            <p className="text-[14px] leading-relaxed text-neutral-100">
              {POSITIONING.line1}
            </p>
            <p className="mt-2 text-[13px] leading-relaxed text-neutral-400">
              {POSITIONING.line2}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
